import React from 'react'

const Manual_menu_promociones = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          MENÚ - Promociones
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Esta guía proporciona un método detallado para crear promociones dentro de un sistema,
          permitiendo administrar estrategias de ventas, personalizar descuentos por ítem o categoría y
          establecer plazos y condiciones para asegurar campañas precisas y oportunas.
        </p>
        <iframe
          src="https://scribehow.com/embed/MENU__Promociones___7FrgnF2QU-iIU4xbPFtLg?as=scrollable"
          className="scribe-iframe-general-12"
          width="100%"
          height="7100"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_menu_promociones